<template>
    <section class="breadcrumbs-custom">
        <div class="parallax-container">
            <div class="material-parallax parallax"><img src="/assets/images/breadcrumbs-bg.jpg" alt="breadcrumbs" ></div>
            <div class="breadcrumbs-custom-body parallax-content context-dark">
                <div class="container">
                    <h2 class="breadcrumbs-custom-title">Careers</h2>
                </div>
            </div>
        </div>
        <div class="breadcrumbs-custom-footer">
            <div class="container">
                <ul class="breadcrumbs-custom-path">
                    <li><router-link to="/" class="rd-nav-link">Home</router-link></li>
                    <li class="active">Careers</li>
                </ul>
            </div>
        </div>
    </section>

    <section class="section section-xl bg-default text-md-start">
        <div class="container">
            <div class="row row-50 justify-content-center">
                <div class="col-lg-12 pe-lg-5">
                    <div class="title-classic mb-4">
                        <h3 class="title-classic-title">Join Our Team</h3>
                        <p class="title-classic-subtitle text-muted">We are always looking for passionate people to join our team. Fill out the form below to apply for open positions or express your interest.</p>
                    </div>
                    <form class="mt-4" method="post" @submit.prevent="submitCareer">
                        <div class="row row-20 row-md-30">
                            <div class="col-sm-6">
                                <div class="form-wrap">
                                    <input v-model="form.first_name" type="text" class="form-input" id="career-first-name" required />
                                    <label class="form-label" for="career-first-name">First Name</label>
                                    <span v-if="validationErrors.first_name" class="text-danger small">{{ validationErrors.first_name[0] }}</span>
                                </div>
                            </div>
                            <div class="col-sm-6">
                                <div class="form-wrap">
                                    <input v-model="form.last_name" type="text" class="form-input" id="career-last-name" required />
                                    <label class="form-label" for="career-last-name">Last Name</label>
                                    <span v-if="validationErrors.last_name" class="text-danger small">{{ validationErrors.last_name[0] }}</span>
                                </div>
                            </div>
                            <div class="col-sm-6">
                                <div class="form-wrap">
                                    <input v-model="form.email" type="email" class="form-input" id="career-email" required />
                                    <label class="form-label" for="career-email">E-mail</label>
                                    <span v-if="validationErrors.email" class="text-danger small">{{ validationErrors.email[0] }}</span>
                                </div>
                            </div>
                            <div class="col-sm-6">
                                <div class="form-wrap">
                                    <input v-model="form.mobile_no" type="text" class="form-input" id="career-phone" required />
                                    <label class="form-label" for="career-phone">Mobile Number</label>
                                    <span v-if="validationErrors.mobile_no" class="text-danger small">{{ validationErrors.mobile_no[0] }}</span>
                                </div>
                            </div>
                            <div class="col-12">
                                <div class="form-wrap">
                                    <label class="form-label" for="career-message">Cover Letter / Description</label>
                                    <textarea v-model="form.description" rows="4" class="form-input textarea-lg" id="career-message" required></textarea>
                                    <span v-if="validationErrors.description" class="text-danger small">{{ validationErrors.description[0] }}</span>
                                </div>
                            </div>
                            <div class="col-12 mt-4">
                                <div class="form-wrap" style="position: static;">
                                    <label class="d-block mb-2 fw-medium text-dark" for="career-resume">Resume / CV (Required)</label>
                                    <input type="file" id="career-resume" class="form-control" accept=".pdf,.doc,.docx" @change="handleFileUpload" required />
                                    <span v-if="validationErrors.file" class="text-danger small">{{ validationErrors.file[0] }}</span>
                                </div>
                            </div>
                        </div>
                        <button type="submit" :disabled="loading" class="button button-lg button-secondary button-zakaria mt-4">
                            {{ loading ? "Submitting..." : "Submit Application" }}
                        </button>
                        <!-- Success message -->
                        <div v-if="success" class="mt-4 text-success font-weight-bold">{{ success }}</div>
                        <div v-if="validationErrors.form" class="mt-4 text-danger font-weight-bold">{{ validationErrors.form[0] }}</div>
                    </form>
                </div>               
            </div>
        </div>
    </section>
</template>

<script setup>
import { ref } from 'vue';
import { api } from '@/plugins/axios';

const form = ref({
    first_name: '',
    last_name: '',
    email: '',
    mobile_no: '',
    description: ''
});

const resumeFile = ref(null);
const loading = ref(false);
const success = ref('');
const validationErrors = ref({});

const handleFileUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
        resumeFile.value = file;
    }
}

const submitCareer = async () => {
    loading.value = true;
    success.value = '';
    validationErrors.value = {};

    let formData = new FormData();
    formData.append('first_name', form.value.first_name);
    formData.append('last_name', form.value.last_name);
    formData.append('email', form.value.email);
    formData.append('mobile_no', form.value.mobile_no);
    formData.append('description', form.value.description);
    
    if (resumeFile.value) {
        formData.append('file', resumeFile.value);
    }

    try {
        const response = await api.post('careers', formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            }
        });
        
        success.value = response.data.message || 'Your application has been submitted successfully.';
        // Reset form
        form.value = {
            first_name: '',
            last_name: '',
            email: '',
            mobile_no: '',
            description: ''
        };
        resumeFile.value = null;
        document.getElementById('career-resume').value = ""; // clear file input visually
    } catch (error) {
        if (error.response && error.response.status === 422) {
            validationErrors.value = error.response.data.data || {};
        } else {
            console.error("An error occurred", error);
            validationErrors.value = { form: ['An unexpected error occurred. Please try again.'] };
        }
    } finally {
        loading.value = false;
    }
}
</script>
